import {styled} from '@linaria/react';
import React, {type JSX} from 'react';
import {COLORS} from '../../../constants/colors';
import {AriaButtonLinkType} from '../../../types/AriaButtonLink';
import {Ripple} from '../Ripple/Ripple';

type RoundButtonColorType = 'secondary' | 'primary';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  as?:
    | keyof JSX.IntrinsicElements
    | React.ComponentType<React.PropsWithChildren>;
  disabledRipple?: boolean;
  backgroundColor?: RoundButtonColorType;
  className?: string;
  style?: React.CSSProperties;
  refObject?: React.RefObject<HTMLElement | null>;
  disableTabNavigation?: boolean;
}

/**
 * @deprecated
 * Use atoms/ButtonsDeprecated/Button.tsx instead
 */
export const CircleButton = React.forwardRef<
  HTMLElement,
  Props & AriaButtonLinkType
>(function CircleButton({disabledRipple, ...props}, refObject) {
  return (
    <Wrapper data-button-type={props.backgroundColor}>
      {disabledRipple ? (
        <StyledButton
          {...props}
          ref={refObject as React.RefObject<HTMLButtonElement>}
        />
      ) : (
        <Ripple as={StyledButton} {...props} ref={refObject} />
      )}
    </Wrapper>
  );
});

const Wrapper = styled.div`
  display: contents;
`;

const StyledButton = styled.button<{
  backgroundColor?: RoundButtonColorType;
}>`
  width: 36px;
  height: 36px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 36px;
  padding: 5px;
  background-color: transparent;

  [data-button-type='primary'] & {
    color: ${COLORS.White};
    background-color: ${COLORS.Black};
  }

  [data-button-type='secondary'] & {
    background-color: ${COLORS.White};
  }

  overflow: visible;
  display: inline-block;
  border-radius: 50%;

  &:focus-visible {
    outline: 2px auto Highlight;
    outline: 2px auto -webkit-focus-ring-color;
  }
`;
